import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { User, Mail, Phone, MapPin, Calendar, Search } from 'lucide-react';
import { mockClients } from '../mock/data';

const Clients = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredClients = mockClients.filter(client =>
    client.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    client.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="container mx-auto px-4 py-8">
      <motion.h1
        className="text-4xl font-extrabold text-gray-900 mb-8 text-center bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Nuestros Clientes
      </motion.h1>

      <motion.div
        className="mb-8 bg-white/90 backdrop-blur-xl border border-gray-200/50 rounded-2xl p-4 shadow-lg flex items-center gap-3"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <Search className="w-6 h-6 text-gray-500" />
        <input
          type="text"
          placeholder="Buscar cliente por nombre o email..."
          className="flex-1 p-2 bg-transparent outline-none text-gray-800 placeholder-gray-400"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredClients.length > 0 ? (
          filteredClients.map((client, index) => (
            <motion.div
              key={client.id}
              className="bg-white/90 backdrop-blur-xl border border-gray-200/50 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4, delay: 0.3 + index * 0.1 }}
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="p-3 rounded-full bg-purple-100">
                  <User className="w-6 h-6 text-purple-600" />
                </div>
                <h2 className="text-2xl font-bold text-gray-800">{client.name}</h2>
              </div>
              <div className="space-y-3 text-gray-600">
                <p className="flex items-center gap-2"><Mail className="w-4 h-4 text-blue-500" /> {client.email}</p>
                <p className="flex items-center gap-2"><Phone className="w-4 h-4 text-green-500" /> {client.phone}</p>
                <p className="flex items-center gap-2"><MapPin className="w-4 h-4 text-red-500" /> {client.address}</p>
                <p className="flex items-center gap-2"><Calendar className="w-4 h-4 text-orange-500" /> Última compra: {client.lastPurchase}</p>
              </div>
            </motion.div>
          ))
        ) : (
          <motion.div
            className="col-span-full bg-white/90 backdrop-blur-xl border border-gray-200/50 rounded-2xl p-8 text-center shadow-lg"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <p className="text-xl text-gray-600">No se encontraron clientes con ese criterio de búsqueda.</p>
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default Clients;